import React, { Component } from 'react';

const TERMS_CONTENT_URL = '/privacy/privacy.json';

export default class extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            error: null,
        };
    }

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.language !== this.props.language) {
            this.fetchContent();
        }
    }

    fetchContent() {
        // Cache-bust so edits to the JSON are reflected without a hard refresh
        fetch(`${TERMS_CONTENT_URL}?v=${Date.now()}`)
            .then(res => {
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                return res.json();
            })
            .then(data => this.setState({ content: data, error: null }))
            .catch(err => this.setState({ error: err.message }));
    }

    renderContent() {
        const { language } = this.props;
        const { content, error } = this.state;

        if (error) {
            return <p className="text-danger">Could not load terms content: {error}</p>;
        }

        if (!content) {
            return <p>Loading&hellip;</p>;
        }

        const key = language ? language.toLowerCase() : 'nl_be';
        const locale = content[key] || content['nl_be'];

        if (!locale) {
            return <p>No content available for locale: {key}</p>;
        }

        return (
            <>
                <h2>{locale.title}</h2>
                <p dangerouslySetInnerHTML={{ __html: locale.body }} />
            </>
        );
    }

    render() {

        const { t } = this.props;

        return (
            <>
                <div className="container mb-5 mt-3">
                    <div className="row">
                        <div className="col-12">
                            <div className="terms">
                            <h1>{t('Privacy Policy')}</h1>
                            {this.renderContent()}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
};
                        
